export default __webpack_public_path__ + "static/media/img-table-30anos.32465011.png";